import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="30" height="26" viewBox="0 0 30 26" xmlns="http://www.w3.org/2000/svg" {...this.props}><g fill="none" fillRule="evenodd"><path fill="#2EB571" d="M10.236 0L0 17.609l4.566 8.345 4.866-8.372 5.461-9.394z" /><path fill="#3F82F7" d="M20.219 17.552l-10.787.03-4.866 8.372 20.43-.004 4.915-8.426z" /><path fill="#FDD04A" d="M10.236 0l4.657 8.188 5.326 9.364 9.692-.028L19.636.028z" /></g></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/google-drive.svg